import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var ChevronRight = function (props) { return (React.createElement(Icon, __assign({ width: '20px', height: '20px', viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, props),
    React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M5.20101 13.3206C4.96357 13.0894 4.95846 12.7095 5.1896 12.4721L9.54308 8.00001L5.1896 3.5279C4.95846 3.29046 4.96357 2.9106 5.20101 2.67945C5.43845 2.44831 5.81832 2.45341 6.04946 2.69086L10.8104 7.58148C11.0371 7.81442 11.0371 8.18559 10.8104 8.41853L6.04946 13.3092C5.81832 13.5466 5.43845 13.5517 5.20101 13.3206Z', fill: 'currentColor' }))); };

export { ChevronRight as default };
//# sourceMappingURL=ChevronRight.js.map
